import React from 'react'
import PropTypes from 'prop-types'
import { midas } from '@resurs/midas'

export const FormGroup = ({ children, fieldCaption, fieldName }) => {
  return (
    <div className={midas.formGroup}>
      <label className={midas.formLabel} htmlFor={fieldName}>
        {fieldCaption}
      </label>
      {children}
    </div>
  )
}

FormGroup.propTypes = {
  fieldName: PropTypes.string,
  fieldCaption: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
}

FormGroup.defaultProps = {
  children: null,
  fieldName: '',
  fieldCaption: '',
}
